import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { AwakeMemberProvider } from "@/lib/awakeContext";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import ScrollToTop from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import Run from "@/pages/Run";
import Results from "@/pages/Results";
import AuthCallback from "@/pages/AuthCallback";

import MemberShell from "@/pages/member/MemberShell";
import MemberOverview from "@/pages/member/Overview";
import Foundations from "@/pages/member/Foundations";
import Pillars from "@/pages/member/Pillars";
import CalendarPage from "@/pages/member/CalendarPage";
import Coach from "@/pages/member/Coach";
import Audits from "@/pages/member/Audits";
import Admin from "@/pages/member/Admin";

function PublicChrome({ children }) {
  return (
    <>
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render to handle race condition with AuthProvider
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Public marketing + audit funnel */}
      <Route path="/" element={<PublicChrome><Landing /></PublicChrome>} />
      <Route path="/run" element={<PublicChrome><Run /></PublicChrome>} />
      <Route path="/results/:id" element={<PublicChrome><Results /></PublicChrome>} />

      {/* Old /dashboard URL → /app */}
      <Route path="/dashboard" element={<Navigate to="/app" replace />} />

      {/* Member workspace (auth-gated inside MemberShell) */}
      <Route path="/app" element={<MemberShell />}>
        <Route index element={<MemberOverview />} />
        <Route path="foundations" element={<Foundations />} />
        <Route path="pillars" element={<Pillars />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="coach" element={<Coach />} />
        <Route path="audits" element={<Audits />} />
        <Route path="admin" element={<Admin />} />
      </Route>

      <Route path="*" element={<PublicChrome><Landing /></PublicChrome>} />
    </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AwakeMemberProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </AwakeMemberProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
